import {printAssistentSocket} from "./print-assistent"


export function connectSockets (){
    printAssistentSocket.connect();
}